import { toCamelCase } from '../../../utils/string';
var GetJobByFileIdDto = /** @class */ (function () {
    function GetJobByFileIdDto(data) {
        this.business = data.business;
        this.script = data.script;
        this.scriptData = data.scriptData;
        this.sources = data.sources;
    }
    GetJobByFileIdDto.fromGetJobByFileIdResponse = function (_a) {
        var data = _a.job.data;
        return new GetJobByFileIdDto({
            business: data.business,
            script: data.script,
            scriptData: data.scriptData[toCamelCase(data.script)],
            sources: data.sources,
        });
    };
    return GetJobByFileIdDto;
}());
export { GetJobByFileIdDto };
//# sourceMappingURL=GetJobByFileIdDto.js.map